module.exports = __webpack_public_path__ + "static/media/nft-17.0c85af51.jpg";